module.exports = __webpack_public_path__ + "static/media/market_grey.75717107.svg";